import { render, staticRenderFns } from "./loaction.vue?vue&type=template&id=9be2f49a&scoped=true&"
import script from "./loaction.vue?vue&type=script&lang=js&"
export * from "./loaction.vue?vue&type=script&lang=js&"
import style0 from "./loaction.vue?vue&type=style&index=0&id=9be2f49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be2f49a",
  null
  
)

export default component.exports